import { FunctionComponent, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { UserType } from "./ProtectedRoute";

const Footer: FunctionComponent = () => {
  const { accounts, instance } = useMsal();
  const [userType, setUserType] = useState<UserType>(UserType.GUEST);

  useEffect(() => {
    if (accounts.length > 0) {
      const tokenRequest = {
        account: accounts[0],
        // This should not be hardcoded
        scopes: ["api://6e757afd-c770-4710-9789-5c1db5eaf601/access_as_user"],
      };

      instance
        .acquireTokenSilent(tokenRequest)
        .then((response) => {
          const claims = response.account.idTokenClaims as any;
          const userEnum =
            claims?.extension_UserEnum ||
            claims?.UserEnum ||
            claims?.UserType ||
            claims?.roles?.[0];

          if (typeof userEnum === "number") {
            setUserType(userEnum as UserType);
          } else if (typeof userEnum === "string") {
            switch (userEnum) {
              case "STANDBYUSER":
              case "1":
                setUserType(UserType.STANDBYUSER);
                break;
              case "UPFITTER":
              case "2":
                setUserType(UserType.UPFITTER);
                break;
              case "ENDCUSTOMER":
              case "3":
                setUserType(UserType.ENDCUSTOMER);
                break;
            }
          }
        })
        .catch(async (e) => {
          console.log("Token acquisition failed in Footer:", e);
        });
    }
  }, [accounts, instance]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        bottom: 0,
        minHeight: 80,
        mt: { md: 0, xs: 4 },
      }}
    >
      <Box
        sx={{
          borderTop: "solid 1px #ccc",
          pt: 8,
          pb: 2,
          justifyContent: "center",
          display: "flex",
        }}
      >
        <Box sx={{ width: "50%", textAlign: "center" }}>
          Device Management Platform - Copyright © 2023 Standby AB
          <Box sx={{ alignSelf: "center", pb: 4 }}>
            {userType === UserType.STANDBYUSER && (
              <Box>
                {process.env.REACT_APP_ENV === "production" && (
                  <span style={{ marginRight: 20, color: "red" }}>
                    (Environment: Production)
                  </span>
                )}
                {process.env.REACT_APP_ENV === "test" && (
                  <span style={{ marginRight: 20, color: "orange" }}>
                    (Environment: Test)
                  </span>
                )}
                {process.env.REACT_APP_ENV === "development" && (
                  <span style={{ marginRight: 20, color: "green" }}>
                    (Environment: Development)
                  </span>
                )}
                {process.env.REACT_APP_ENV === "local" && (
                  <span style={{ marginRight: 20, color: "darkgreen" }}>
                    (Environment: Local)
                  </span>
                )}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
